import { IAdjustmentStats, IAdjustmentStatsParams, IRtiIntervention, IRtiInterventionData, IRtiInterventionItem, IRtiInterventionParams, IRtiRiskCriteriaOne, IRtiRiskCriteriaOneData, IRtiRiskCriteriaOneDocument, IRtiRiskCriteriaOneItem, IRtiRiskCriteriaOneParams, IRtiRiskCriteriaThree, IRtiRiskCriteriaThreeData, IRtiRiskCriteriaThreeItem, IRtiRiskCriteriaThreeParams, ITableRes } from 'types'

import { baseApi } from './baseApi'

export const rtiAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    GET_rtiInterventions: builder.query<ITableRes<IRtiInterventionItem>, IRtiInterventionParams>({
      query: (params) => ({
        url: '/rti-interventions/',
        params,
      }),
      providesTags: ['rti-interventions'],
    }),
    GET_rtiInterventionById: builder.query<IRtiIntervention, string>({
      query: (id) => {
        return {
          url: `/rti-interventions/${id}/`,
        }
      },
      providesTags: ['rti-interventions'],
    }),
    POST_rtiIntervention: builder.mutation<IRtiIntervention, IRtiInterventionData>({
      query: (body) => ({
        url: `/rti-interventions/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['rti-interventions', 'benchmark'],
    }),
    PUT_rtiIntervention: builder.mutation<IRtiIntervention, { id: string; body: IRtiInterventionData }>({
      query: ({ id, body }) => ({
        url: `/rti-interventions/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['rti-interventions', 'rti-intervention', 'benchmark'],
    }),
    DELETE_rtiIntervention: builder.mutation<IRtiIntervention, string>({
      query: (id) => ({
        url: `/rti-interventions/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['rti-interventions', 'benchmark'],
    }),


    // Criteria 1
    GET_rtiRiskCriteriaOneList: builder.query<ITableRes<IRtiRiskCriteriaOneItem>, IRtiRiskCriteriaOneParams>({
      query: (params) => ({
        url: '/rti-risk-criteria-one/',
        params,
      }),
      providesTags: ['rti-risk-criteria-one'],
    }),
    GET_rtiRiskCriteriaOneById: builder.query<IRtiRiskCriteriaOne, string>({
      query: (id) => {
        return {
          url: `/rti-risk-criteria-one/${id}/`,
        }
      },
      providesTags: ['rti-risk-criteria-one'],
    }),
    POST_rtiRiskCriteriaOne: builder.mutation<IRtiRiskCriteriaOne, IRtiRiskCriteriaOneData>({
      query: (body) => ({
        url: `/rti-risk-criteria-one/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['rti-risk-criteria-one-list', 'rti-risk-criteria-one'],
    }),
    PUT_rtiRiskCriteriaOne: builder.mutation<IRtiRiskCriteriaOne, { id: string; body: IRtiRiskCriteriaOneData }>({
      query: ({ id, body }) => ({
        url: `/rti-risk-criteria-one/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['rti-risk-criteria-one-list', 'rti-risk-criteria-one'],
    }),
    DELETE_rtiRiskCriteriaOne: builder.mutation<IRtiRiskCriteriaOne, string>({
      query: (id) => ({
        url: `/rti-risk-criteria-one/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['rti-risk-criteria-one-list', 'rti-risk-criteria-one'],
    }),
    

    //Documents
    POST_rtiRiskCriteriaOneDocument: builder.mutation<IRtiRiskCriteriaOne, {student_id: string, body: IRtiRiskCriteriaOneDocument}>({
      query: ({student_id ,body}) => ({
        url: `/rti-risk-criteria-one/${student_id}/add-performance-document/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['rti-risk-criteria-one-documents'],
    }),
    PUT_rtiRiskCriteriaOneDocument: builder.mutation<IRtiRiskCriteriaOne, { id: string; student_id: string, body: IRtiRiskCriteriaOneDocument }>({
      query: ({ id, student_id, body }) => ({
        url: `/rti-risk-criteria-one/${id}/edit-performance-document/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['rti-risk-criteria-one-documents'],
    }),
    DELETE_rtiRiskCriteriaOneDocument: builder.mutation<IRtiRiskCriteriaOne, {id: string, student_id: string}>({
      query: ({ id, student_id }) => ({
        url: `/rti-risk-criteria-one/${student_id}/delete-performance-document/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['rti-risk-criteria-one-documents'],
    }),


    // Criteria Three

    GET_rtiRiskCriteriaThreeList: builder.query<ITableRes<IRtiRiskCriteriaThreeItem>, IRtiRiskCriteriaThreeParams>({
      query: (params) => ({
        url: '/rti-risk-criteria-three/',
        params,
      }),
      providesTags: ['rti-risk-criteria-three'],
    }),
    GET_rtiRiskCriteriaThreeById: builder.query<IRtiRiskCriteriaThree, string>({
      query: (id) => {
        return {
          url: `/rti-risk-criteria-three/${id}/`,
        }
      },
      providesTags: ['rti-risk-criteria-three'],
    }),
    POST_rtiRiskCriteriaThree: builder.mutation<IRtiRiskCriteriaThree, IRtiRiskCriteriaThreeData>({
      query: (body) => ({
        url: `/rti-risk-criteria-three/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['rti-risk-criteria-three-list', 'rti-risk-criteria-three'],
    }),
    PUT_rtiRiskCriteriaThree: builder.mutation<IRtiRiskCriteriaThree, { id: string; body: IRtiRiskCriteriaThreeData }>({
      query: ({ id, body }) => ({
        url: `/rti-risk-criteria-three/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['rti-risk-criteria-three-list', 'rti-risk-criteria-three'],
    }),
    DELETE_rtiRiskCriteriaThree: builder.mutation<IRtiRiskCriteriaThree, string>({
      query: (id) => ({
        url: `/rti-risk-criteria-three/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['rti-risk-criteria-three-list', 'rti-risk-criteria-three'],
    }),
    GET_adjustmentStats: builder.query<IAdjustmentStats[], IAdjustmentStatsParams>({
      query: (params) => ({
        url: '/adjustments/stats/',
        params
      }),
      providesTags: ['adjustments'],
    }),
    GET_rtiErrorCodesSelect: builder.query<any, any>({
      query: (params) => ({
        url: '/rti-error-codes/',
        params
      }),
      transformResponse: (response: any, meta: any, arg: any) => {
        const hasMore = Boolean(response?.next)
        const count = response?.count || 0
        let list = response?.results.filter(r => !arg.is_enabled || (r.is_enabled === arg.is_enabled))
        if(arg.categories)
          list = list.filter(r => r.category && arg.categories.includes(r.category.id))
        return {
          list: list || [],
          count,
          hasMore,
        }
      },
      providesTags: ['rti-error-codes'],
    }),
  }),


})

export const {
  useGET_rtiInterventionsQuery,
  useGET_rtiInterventionByIdQuery,
  usePOST_rtiInterventionMutation,
  usePUT_rtiInterventionMutation,
  useDELETE_rtiInterventionMutation,

  useGET_rtiRiskCriteriaOneListQuery,
  useGET_rtiRiskCriteriaOneByIdQuery,
  usePOST_rtiRiskCriteriaOneMutation,
  usePUT_rtiRiskCriteriaOneMutation,
  useDELETE_rtiRiskCriteriaOneMutation,
  usePOST_rtiRiskCriteriaOneDocumentMutation,
  usePUT_rtiRiskCriteriaOneDocumentMutation,
  useDELETE_rtiRiskCriteriaOneDocumentMutation,


  useGET_rtiRiskCriteriaThreeListQuery,
  useGET_rtiRiskCriteriaThreeByIdQuery,
  usePOST_rtiRiskCriteriaThreeMutation,
  usePUT_rtiRiskCriteriaThreeMutation,
  useDELETE_rtiRiskCriteriaThreeMutation,

  useGET_adjustmentStatsQuery,
  useGET_rtiErrorCodesSelectQuery

} = rtiAPI
